import kwaiFreeShippingBenefit from '@/assets/images_detail/kwai_free_shipping_benefit.png';
import MerchantFreeShippingBenefit from '@/assets/images_detail/merchant_free_shipping_benefit.png';
import LocalProductBenefit from '@/assets/images_detail/local_product_benefit.png';
import { useMemoizedFn } from 'ahooks';
interface ProductBenifits {
    [key: string]: any;
}
// store_free_shipping 商家包邮  shipping_coupon 运费券包邮   local_product 本地发货
// 商品利益点标签透出 AB实验 https://docs.corp.kuaishou.com/d/home/fcABJiy0vyN1OI7rQGHp_Xwsc
// 已推全

// let loading = false;

const productBenifits = [
    {
        id: 'store_free_shipping',
        img: MerchantFreeShippingBenefit,
        style: 1,
        width: 74,
        height: 22,
    },
    {
        id: 'shipping_coupon',
        img: kwaiFreeShippingBenefit,
        style: 1,
        width: 74,
        height: 22,
    },
    {
        id: 'local_product',
        img: LocalProductBenefit,
        style: 1,
        width: 97,
        height: 22,
    },
] as ProductBenifits;

// 是否需要展示当前图片标签
export const showBenifitsFun = (id, item, old = false) => {
    const benefit = item.extraInfo?.benefit || item.extraInfoView?.benefitList || [];
    // 商家包邮
    if (id === 'store_free_shipping') {
        // 未命中，使用线上样式
        if (old) {
            return false;
        }
        return benefit.includes(3);
    }
    // 优惠券包邮
    if (id === 'shipping_coupon') {
        return benefit.includes(2);
    }
    // 本地发货
    if (id === 'local_product') {
        return benefit.includes(1);
    }
};

// 运费券和商品券在一起，list中需要过滤掉运费券
export const filterCouponList = (couponList: any[]) => {
    return couponList?.filter(item => {
        return item.discountFeeType !== 3;
    });
};

// 曝光/点击商品卡需要曝光的参数
export const getBenifitsLogParams = item => {
    let log = productBenifits
        ?.filter(benifit => {
            return showBenifitsFun(benifit.id, item);
        })
        .map(benifit => benifit.id)
        .join(',');
    // 有秒杀活动，添加flash_sale到利益点的埋点字段中
    if (item?.activityInfo?.activityId && item?.activityInfo?.status === 2) {
        log = `${log},flash_sale`;
    }
    if (item?.priceDiscountDetail?.shippingDisplayMinThresholdDesc) {
        log = `${log},SHIPPING_FEE_COUPONS`;
    }
    return log;
};

export function useShowProductBenifits() {
    return {
        productBenifits,
        showBenifitsFun,
        filterCouponList,
        getBenifitsLogParams,
    };
}
